// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2B73I","header":"MergedInvoice_header__1zTEx"};